<mat-form-field
  class="w-full"
  [class]="inputClass()"
  appearance="outline"
>
  @if (showLabel()) {
    <mat-label>Teams room</mat-label>
  }
  <input
    (input)="onInput($any($event.target).value)"
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="isReadonly()"
    [placeholder]="showLabel() ? 'Search a synced Teams room' : 'Teams room'"
    [readonly]="isReadonly()"
    [value]="typedValue()"
    matInput
  />
  @if (isReadonly()) {
    <button
      type="button"
      class="bg-transparent text-xs text-ui-dark font-semibold px-2 mx-3 rounded-md border border-ui-gray-light leading-[22px]"
      (click)="onEdit()"
      matSuffix
    >
      Edit
    </button>
  }
  @if (canClear()) {
    <button
      type="button"
      (click)="onClear()"
      aria-label="Clear"
      matSuffix
    >
      <i class="icon-close"></i>
    </button>
  }
  @if (isEditing()) {
    <button
      type="button"
      class="text-white font-semibold bg-ui-green-light hover:bg-ui-green-350 active:bg-ui-green-light px-2 mx-3 text-xs leading-6 rounded-md"
      (click)="onSave()"
      matSuffix
    >
      Save
    </button>
  }
  <mat-autocomplete
    (optionSelected)="onOptionSelected($event.option.value)"
    #auto="matAutocomplete"
  >
    @for (room of filteredRooms(); track room.id) {
      <mat-option [value]="room.id">{{ room.email }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
